import type React from "react";

import { paidLabel, paidTitle } from "./paidStorage";
import type { PaidAgg } from "./paidStorage";

/** Плашка рядом с названием кластера. Показывается только при paid_qty > 0. Стиль — как у
 *  соседних бейджей строки («на вывод», «нет движения»). */
export function PaidStorageBadge({
  paid,
  horizon = 30,
}: {
  paid: PaidAgg | undefined;
  horizon?: number;
}): React.ReactElement | null {
  if (!paid || paid.paid_qty <= 0) return null;
  return (
    <span
      className="shrink-0 rounded bg-rose-100 px-1 text-[10px] font-medium text-rose-700 dark:bg-rose-950 dark:text-rose-300"
      title={paidTitle(paid, horizon)}
      data-testid="paid-storage-badge"
    >
      {paidLabel(paid, horizon)}
    </span>
  );
}
